var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBackView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 73,
    viewBox: "0 0 87 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id card-passport-badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M83.8726 17.085H3.10639C1.39078 17.085 0 18.4757 0 20.1914V69.8937C0 71.6093 1.39078 73 3.10639 73H83.8726C85.5882 73 86.979 71.6093 86.979 69.8937V20.1914C86.979 18.4757 85.5882 17.085 83.8726 17.085Z",
    fill: "#57A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.7227 0V23.298H51.2546V0H35.7227ZM43.4886 10.8724C42.8743 10.8724 42.2737 10.6902 41.7628 10.3489C41.252 10.0075 40.8538 9.52237 40.6187 8.95475C40.3836 8.38713 40.3221 7.76254 40.4419 7.15996C40.5618 6.55738 40.8577 6.00387 41.2921 5.56943C41.7265 5.13499 42.28 4.83914 42.8826 4.71928C43.4852 4.59942 44.1098 4.66093 44.6774 4.89605C45.245 5.13117 45.7302 5.52932 46.0715 6.04016C46.4129 6.55101 46.595 7.1516 46.595 7.76598C46.5926 8.5891 46.2645 9.37779 45.6825 9.95982C45.1004 10.5419 44.3118 10.8699 43.4886 10.8724Z",
    fill: "#E0E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.5966 15.5317H40.3838V18.6381H46.5966V15.5317Z",
    fill: "#2488FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.3186 29.5107H35.7227V32.6171H82.3186V29.5107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M82.3186 37.2769H35.7227V40.3832H82.3186V37.2769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M51.2546 45.043H35.7227V48.1494H51.2546V45.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M52.8083 23.2983H37.2764V24.8515H52.8083V23.2983Z",
    fill: "#005ECE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M52.8086 17.085H51.2554V24.8509H52.8086V17.085Z",
    fill: "#005ECE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBackView);
export default __webpack_public_path__ + "static/media/UploadBackView.7f97bf66f4b73dfa8432e5340ffbe8f2.svg";
export { ForwardRef as ReactComponent };